import { css } from 'styled-components';
import token from 'styled-token';
import { StyledFormActions } from '../../components/FormActions/FormActions.styles';
import { StyledFormField } from '../../components/FormField/FormField.styles';
import { spaceMixin } from '../spaceMixin';

/** @class FormMixin */
/** @method */
export var FormMixin = function FormMixin(props) {
  return token({
    formFieldMarginBottom: 'Form.FormField.marginBottom',
    formActionMarginTop: 'Form.FormAction.marginTop'
  }, function (_ref) {
    var formFieldMarginBottom = _ref.formFieldMarginBottom,
      formActionMarginTop = _ref.formActionMarginTop;
    return css(["", ":not(:last-child){margin-bottom:", ";}", "{margin-top:", ";}"], StyledFormField, formFieldMarginBottom ? formFieldMarginBottom + "px" : spaceMixin('sm')(props), StyledFormActions, formActionMarginTop ? formActionMarginTop + "px" : spaceMixin('lg')(props));
  })(props);
};